module.exports = __webpack_public_path__ + "img/loading.6a1f923f.svg";